import React, { useEffect, useState } from 'react';
import { Alert, Button, Card, CardContent, Container, Stack, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { api } from '../../api';
import { useT } from '../../localization/LocalizationProvider';

export function SavedQuizzesPage() {
  const t = useT();
  const [quizzes, setQuizzes] = useState([]);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const load = async () => setQuizzes(await api.getQuizzes());
  useEffect(() => { load(); }, []);

  return (
    <Container>
      <Stack spacing={3}>
        <Typography variant="h4">{t('Admin.SavedQuizzes.Title')}</Typography>
        <Typography color="text.secondary">
          {t('Admin.SavedQuizzes.Description')}
        </Typography>
        {message && <Alert severity="success">{message}</Alert>}
        {error && <Alert severity="error">{error}</Alert>}
        <Card>
          <CardContent>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>{t('Admin.SavedQuizzes.QuizName')}</TableCell>
                  <TableCell>{t('Admin.SavedQuizzes.QuizTitle')}</TableCell>
                  <TableCell>{t('Admin.SavedQuizzes.PlayerCount')}</TableCell>
                  <TableCell>{t('Admin.SavedQuizzes.Rounds')}</TableCell>
                  <TableCell>{t('Common.Actions')}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {quizzes.map((quiz) => (
                  <TableRow key={quiz.id}>
                    <TableCell>{quiz.internalName}</TableCell>
                    <TableCell>{quiz.publicTitle}</TableCell>
                    <TableCell>{quiz.playerCount ?? (Array.isArray(quiz.enabledPlayers) ? quiz.enabledPlayers.length : 1)}</TableCell>
                    <TableCell>{quiz.roundsCount}</TableCell>
                    <TableCell>
                      <Stack direction="row" spacing={1}>
                        <Button size="small" variant="contained" onClick={async () => {
                          try {
                            const loaded = await api.loadQuizToDraft(quiz.id);
                            setMessage(loaded.message);
                            setError('');
                            navigate('/admin/postavke-igre');
                          } catch (err) {
                            setError(err.message);
                            setMessage('');
                          }
                        }}>{t('Common.Edit')}</Button>
                        <Button size="small" color="error" onClick={async () => {
                          try {
                            await api.deleteQuiz(quiz.id);
                            setMessage(t('Admin.SavedQuizzes.Deleted'));
                            setError('');
                            await load();
                          } catch (err) {
                            setError(err.message);
                            setMessage('');
                          }
                        }}>{t('Common.Delete')}</Button>
                      </Stack>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </CardContent>
        </Card>
      </Stack>
    </Container>
  );
}
